import { Guid } from "@/types"

export interface IGetLabelsDashboardItemDto {
    categoryId?: Guid | null
    labelsCount: number
}

export default class LabelsDashboardItem {
    categoryId?: Guid
    labelsCount: number

    constructor(dto: IGetLabelsDashboardItemDto) {
        this.categoryId = dto.categoryId ?? undefined
        this.labelsCount = dto.labelsCount
    }
}
